module.exports = __webpack_public_path__ + "static/media/Channel.6a2bc1f3.svg";